<p-menubar [model]="items">
  <p-splitButton label="{{hoVaTen}}" icon="fa fa-user" class="p-button-text" [model]="infoUserItems"></p-splitButton>
  <button pButton label="Thoát" class="p-button-text" icon="pi pi-power-off" (click)="logout()"></button>
</p-menubar>

<app-change-password [doiMatKhauFlag]="doiMatKhauFlag" (hideDialogEvent)="changeDialogShowPasswordFlag($event)"
  [idUser]="-1"></app-change-password>